import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { AnswersStore } from 'src/app/store/answers-store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-loading-board',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './loading-board.html',
    styleUrls: ['./loading-board.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class LoadingBoardComponent {
 
}
